import { defineStore } from 'pinia'
import axios from 'axios'
import router from '../router'

// Backend API base URL
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token,
    userRole: (state) => state.user?.role || 'guest'
  },
  
  actions: {
    async login(credentials) {
      try {
        this.loading = true
        this.error = null
        
        const response = await axios.post(`${API_URL}/api/auth/login`, credentials)
        
        this.token = response.data.access_token
        localStorage.setItem('token', this.token)
        
        // Fetch user data
        await this.fetchUser()
        
        // Not redirecting here - let the component handle redirect
      } catch (error) {
        this.error = error.response?.data?.message || 'Login failed'
        console.error('Login error:', error)
      } finally {
        this.loading = false
      }
    },
    
    async signup(userData) {
      try {
        this.loading = true
        this.error = null
        
        console.log('Auth store: starting signup request')
        const response = await axios.post(`${API_URL}/api/auth/signup`, userData)
        console.log('Auth store: signup response received:', response.data)
        
        // Automatically log in after signup
        console.log('Auth store: attempting login after successful signup')
        await this.login({
          email: userData.email,
          password: userData.password
        })
        
      } catch (error) {
        console.error('Auth store: Signup error details:', {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        })
        
        this.error = error.response?.data?.message || 'Signup failed. Please check your network connection and try again.'
      } finally {
        this.loading = false
      }
    },
    
    async fetchUser() {
      try {
        if (!this.token) return
        
        console.log('Fetching user data...')
        const response = await axios.get(`${API_URL}/api/users/me`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        
        console.log('User data received:', response.data)
        this.user = response.data.user
        console.log('User role after setting:', this.user?.role)
      } catch (error) {
        console.error('Error fetching user:', error)
        // If token is invalid, logout
        if (error.response?.status === 401) {
          this.logout()
        }
      }
    },
    
    async logout() {
      try {
        await axios.post(`${API_URL}/api/auth/logout`, {}, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        this.token = null
        this.user = null
        localStorage.removeItem('token')
        router.push('/login')
      }
    },
    
    async checkAuth() {
      if (this.token) {
        await this.fetchUser()
      }
    }
  }
})
